var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-indicator__wrapper"},[_c('div',{class:[
      'loading-indicator',
      {
        'loading-indicator--show': _vm.show,
        'loading-indicator--white': _vm.white
      }
    ]},[_c('span',{staticClass:"loading-indicator__dot loading-indicator__dot--1"}),_c('span',{staticClass:"loading-indicator__dot loading-indicator__dot--2"}),_c('span',{staticClass:"loading-indicator__dot loading-indicator__dot--3"})])])}
var staticRenderFns = []

export { render, staticRenderFns }